import { composeFetch } from '@library/http'
import {
  addPath,
  composeRequest,
  goustoHeaders,
  setMethod,
  setServiceUrl,
} from '@library/http/requests'

export type MenuExperimentsResponse = {
  experiments: Record<string, string>
}

const menuExperimentsParser = async (response: Response): Promise<MenuExperimentsResponse> => {
  if (!response.ok) {
    const body = await response.text()
    throw new Error(`service responded with ${response.status}: ${body}`)
  }

  return (await response.json()) as MenuExperimentsResponse
}

const menuExperimentsRequest = composeRequest<void>(
  setServiceUrl('menuexperience', 1),
  addPath('menu/experiments'),
  setMethod('GET'),
  goustoHeaders,
)

export const menuExperimentsFetcher = composeFetch(menuExperimentsRequest, menuExperimentsParser)
